import React from 'react';
import { Box, Typography, Card, CardContent } from '@mui/material';

const Guarantor: React.FC = () => (
  <Box sx={{ p: 3, maxWidth: 700, mx: 'auto' }}>
    <Typography variant="h4" gutterBottom>Guarantor</Typography>
    <Card>
      <CardContent>
        <Typography variant="body1">Guarantor features will be displayed here. (Mock data for now)</Typography>
      </CardContent>
    </Card>
  </Box>
);

export default Guarantor; 